import React, { useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { CreateDebtRequest, UpdateDebtRequest, Customer } from '../../types';
import DebtForm from './DebtForm';
import MovementDialogLayout from './MovementDialogLayout';
import { debtErrorMessage } from '../../utils/debtErrorMessage';
import { useDebtMutations } from '../../hooks/useDebtMutations';

interface PaymentDialogProps {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
  prefilledCustomer?: Customer | null;
}

const PaymentDialog: React.FC<PaymentDialogProps> = ({
  open,
  onClose,
  onSuccess,
  prefilledCustomer,
}) => {
  const { t } = useLanguage();
  const [error, setError] = useState<string | null>(null);
  const { createPaymentMutation } = useDebtMutations();
  const isLoading = createPaymentMutation.isPending;

  const handleSubmit = async (data: CreateDebtRequest | UpdateDebtRequest) => {
    try {
      setError(null);
      await createPaymentMutation.mutateAsync(data as CreateDebtRequest);

      onSuccess();
      onClose();
    } catch (error: unknown) {
      setError(debtErrorMessage(error, t('debts.createError'), t));
    }
  };

  const handleClose = () => {
    if (!isLoading) {
      setError(null);
      onClose();
    }
  };

  return (
    <MovementDialogLayout
      open={open}
      onClose={handleClose}
      title={t('debts.createPayment')}
      hint={t('debts.form.paymentHint')}
      error={error}
      isLoading={isLoading}
    >
      <DebtForm
        onSubmit={handleSubmit}
        onCancel={handleClose}
        isLoading={isLoading}
        isPayment={true}
        prefilledCustomer={prefilledCustomer}
      />
    </MovementDialogLayout>
  );
};

export default PaymentDialog;
